import { InjectionToken } from '@angular/core';

export const DAVESA_MOCK_API_DEFAULT_DELAY = new InjectionToken<number>(
    'DAVESA_MOCK_API_DEFAULT_DELAY'
);
